import { Page, openPage } from '#/views/libs/pages';
import { Doc } from '#/models/docs/Doc';
import { VideoInfo } from '#/models/videos/VideoInfo';
import { createAreaSelectorPage } from '#/views/index/areas/AreaSelectorPage';
import { createCityInfoPage } from '#/views/index/city/CityInfoPage';
import { createRootPageToolbar } from '#/views/components/RootPageToolbar';
import { createVideoPage } from '#/views/components/video/VideoPage';
import { createPdfViewerPage } from '#/views/components/pdf/PdfViewerPage';
import { createMultiLineThumbnailSelector } from '#/views/components/thumbnails/MultiLineThumbnailSelector';
import { createGikaiInfoPage } from '#/views/index/gikai/GikaiInfoPage';

import template from './CatvInfoPage.html';
import { createMyudeDetailPage } from '#/views/index/catv/MyudeDetailPage';

export interface CatvInfoPageOptions {}

export function createCatvInfoPage(options: CatvInfoPageOptions): Page {
  const showBlue = () => {
    openPage(createCityInfoPage({}));
  };

  const showRed = () => {
    openPage(createAreaSelectorPage({}));
  };

  const showGreen = () => {
    openPage(createGikaiInfoPage({}));
  };

  const showYellow = () => {};

  const $toolbar = createRootPageToolbar();

  $toolbar.find('.btn-primary').on('click', (e) => {
    showBlue();
  });
  $toolbar.find('.btn-danger').on('click', (e) => {
    showRed();
  });
  $toolbar.find('.btn-success').on('click', (e) => {
    showGreen();
  });
  $toolbar.find('.btn-warning').on('click', (e) => {
    showYellow();
  });

  const $main = $(template);

  // VOD
  $main.find('.col-md-12').append($(`<h2>ビデオサービス</h2>`));
  $main.find('.col-md-12').append(
    ...createMultiLineThumbnailSelector(VideoInfo.animals, {
      aspectRatio: '16by9',
      colClass: 'col-md-2',
      cols: 6,
      setThumbnail: ($thumbnail, item) => {
        $thumbnail.find('img').attr('src', item.thumbnailUrl);
        $thumbnail.find('h3').text(item.title);

        if (item.live) {
          $thumbnail
            .find('.MultiLineThumbnailSelector__caption')
            .append($('<span class="label label-danger">ライブ配信</span>'));
        } else {
          $thumbnail
            .find('.MultiLineThumbnailSelector__caption')
            .append($('<span class="label label-success">アーカイブ</span>'));
        }
      },
      onFocused: (_, item) => {},
      onClicked: (_, item) => {
        openPage(createVideoPage({ dash: item.dashUrl, hls: item.hlsUrl }));
      },
    })
  );

  // みゅうで！
  $main.find('.col-md-12').append($(`<h2>みゅうで！</h2>`));
  $main.find('.col-md-12').append(
    ...createMultiLineThumbnailSelector(Doc.myude.map(Doc.toPdfDocument), {
      aspectRatio: 'auto',
      colClass: 'col-md-2',
      cols: 6,
      setThumbnail: ($thumbnail, item) => {
        $thumbnail.find('img').attr('src', item.thumbnailUrl);
        $thumbnail.find('h3').text(item.title);
      },
      onFocused(_, item) {},
      onClicked(_, item) {
        openPage(createPdfViewerPage({ pdfDocument: item }));
      },
    })
  );
  const $openMyudeLink = $(`<a href="#" target="_blank">より古いコンテンツを見る</a>`);
  $openMyudeLink.on('click', (e) => {
    e.preventDefault();

    openPage(createMyudeDetailPage({}));
  });
  const $openMyudeRow = $(`<div class="row"><div class="col-md-12"></div></div>`);
  $openMyudeRow.find('.col-md-12').append($openMyudeLink);

  $main.find('.row').last().after($openMyudeRow);

  $('body').append($toolbar);
  $('body').append($main);

  return {
    show: () => {
      $toolbar.show();
      $main.show();
    },
    hide: () => {
      $toolbar.hide();
      $main.hide();
    },
    unmount: () => {},
    onKeydown: (e) => {
      switch (e.which) {
        case VK_BLUE:
          showBlue();
          break;
        case VK_RED:
          showRed();
          break;
        case VK_GREEN:
          showGreen();
          break;
        case VK_YELLOW:
          showYellow();
          break;
        default:
          break;
      }
    },
  };
}
